import { styled } from "@mui/material"

export const Wrapper = styled("div", {
    shouldForwardProp: (props) => props !== "width",
})<{ width?: number }>(({ width }) => ({
    width: width ?? "100px",
}))
